import React 			from 'react';
import PropTypes 	from 'prop-types';

//this.props.classes	: string of classes

export default class LikeButton extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', likes, onClickFunc} = this.props;

		return (
			<button className={"btn btn-like " + classes + (likes.liked ? ' btn-like--is-liked' : '')} onClick={() => onClickFunc()} data-ts-name="likes-btn">
				<i className={"btn-like__icon fa-star" + (likes.liked ? ' fas' : ' far')}/>
				{likes.count < 0 ? 0 : likes.count} {`Like${likes.count != 1 ? 's' : ''}`}
			</button>
		);
	}
}

LikeButton.propTypes = {
		classes: PropTypes.string
	,	likes: PropTypes.shape({
				liked: PropTypes.boolean
			,	count: PropTypes.number.isRequired
		}).isRequired
	,	onClickFunc: PropTypes.func.isRequired
}